/* Source: src/mt-includes/js/src/live_chat/settings.module.js*/
try {
    angular.module('website.LiveChat.settings');
} catch (e) {
    angular.module('website.LiveChat.settings', [])
        .constant('website.LiveChat.settings', null);
}
